import React from "react";
import SocialMedia from "../SocialMedia/SocialMedia";

const Intro = () => {
  return (
    <section className="hero">
      <div className="hero__wrapper">
        <p>Hello, I am</p>
        <h1 className="name">Salman Prottoy</h1>
        <h2 className="subtitle">I create things for the web.</h2>
        <p className="desc">
          I am a 4th Year undergraduate CSE student from{" "}
          <a href="https://www.aiub.edu/">
            {" "}
            American International University-Bangladesh(AIUB)
          </a>
          , Dhaka, Bangladesh. My interest is in <i>
            Software Development
          </i> and <i>Machine Learning</i>.
        </p>
        <a
          href="mailto:salman.prottoy@gmail.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          <button className="">Get in touch</button>
        </a>
        <div className="social">
          <ul>
            <SocialMedia />
          </ul>
        </div>
      </div>
    </section>
  );
};

export default Intro;
